module.exports = __webpack_public_path__ + "static/media/welcome.ffbfc3c0.md";